import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app";
import "react-loading-skeleton/dist/skeleton.css";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
